document.addEventListener('turbolinks:load', () => {

    const jsUpload = document.getElementById('jsUpload')
    const noJsUpload = document.getElementById('noJsUpload')

    const dropZone = document.getElementById('dropZone');
    const fileInput = document.getElementById('file_input');
    const selectedFileName = document.getElementById('added_file');

    const fileSelectDiv = document.getElementById('fileSelect')
    const uploadIndicator = document.getElementById('uploadIndicator')

    const submitStationGroup = document.getElementById("submitStationGroup")

    const colorSelect = document.getElementById('colorSelect')
    const showColorButton = document.getElementById('showColorButton')

    if (jsUpload !== null && noJsUpload !== null && dropZone !== null && fileInput !== null &&
        selectedFileName !== null && fileSelectDiv !== null && uploadIndicator !== null) {
        init()
    }
    if (submitStationGroup!== null && colorSelect !== null && showColorButton !== null){
        init_color()
    }

    function init() {
        fileUpload()
    }

    function init_color(){
        addChangeColorListener()
        addShowColorListener()
    }

    function fileUpload() {
        // show js upload hide no js upload
        jsUpload.classList.remove('hidden')
        noJsUpload.classList.add('hidden')

        // file input
        fileInput.addEventListener('change', function(e) {
            selectedFileName.innerHTML = I18n.t('js.selected_file') + fileInput.value.replace(/^.*[\\\/]/, '');
            checkStorage(e.target.files[0])
        })

        submitStationGroup.addEventListener('click', function () {
            fileSelectDiv.classList.add('hidden');
            uploadIndicator.classList.remove('hidden')
        })

        // dropzone
        dropZone.ondragover = dropZone.ondragenter = function(evt) {
            evt.preventDefault();
        };
        dropZone.ondrop = function(evt) {
            evt.preventDefault();

            if (evt.dataTransfer.files.length > 1) {
                alert("You can't drop more then one file");
                return;
            }

            if (evt.dataTransfer.files[0].type !== 'image/png' && evt.dataTransfer.files[0].type !== 'image/jpeg') {
                alert("The file has an unsupported type. Please use only png files");
                return;
            }

            fileInput.files = evt.dataTransfer.files;
            selectedFileName.innerHTML = I18n.t('js.selected_file') + evt.dataTransfer.files[0].name;
            checkStorage(evt.dataTransfer.files[0])

        };
    }

    function checkStorage(file) {
        let neededStorage = Math.ceil((file.size/1024/1024));
        console.log(neededStorage)
        $.rails.ajax({
            url: "/organizations/check_storage/" + neededStorage,
            type: "get",
            data: "",
        })
    }

    function addChangeColorListener() {
        for (let colorItem of colorSelect.children){
            let colorCheckbox = colorItem.getElementsByTagName('input')[0]
            colorCheckbox.addEventListener('change',function(e){
                updateColorList(e.target)
            })
        }
    }

    function addShowColorListener(){
        showColorButton.addEventListener('click', function(){
            if (showColorButton.dataset.displayed === "false"){
                for (let color_li of colorSelect.children){
                    if(color_li.dataset.primary === "false") {
                        color_li.classList.remove('hidden')
                    }
                }
                showColorButton.dataset.displayed = "true"
                showColorButton.innerHTML = showColorButton.dataset.hide_text
            } else {
                for (let color_li of colorSelect.children){
                    if(color_li.dataset.primary === "false") {
                        color_li.classList.add('hidden')
                    }
                }
                showColorButton.dataset.displayed = "false"
                showColorButton.innerHTML = showColorButton.dataset.display_text
            }
        })
    }

    // update the Color List
    // deselect any color that was selected before and select the color that was clicked on
    // if the current color got clicked, only deselect the current color, so no element is selected afterwards
    // Select by adding green background (Checkbox already gets checked by the click that activates this functions)
    // Deselect by removing green background and remove checked from checkbox of old value
    function updateColorList(changed_item) {
        if(!changed_item.checked){ //only change background of unchecked element
            let colorLabel = changed_item.parentElement
            colorLabel.classList.remove('bg-green-200')
            return
        }
        for (let colorItem of colorSelect.children){
            let colorCheckbox = colorItem.getElementsByTagName('input')[0]
            if(colorCheckbox !== changed_item){
                colorCheckbox.checked = false
                let colorLabel = colorItem.getElementsByTagName('label')[0]
                colorLabel.classList.remove('bg-green-200')
            } else {
                let colorLabel = colorItem.getElementsByTagName('label')[0]
                colorLabel.classList.add('bg-green-200')
            }
        }
    }
});